import Pattern from '../ASSETS/TurboTilesPattern.png';

export const Background = `radial-gradient(transparent, black 100%), url(${Pattern})`;
